(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tlt-mat-image"] && !Shopify.designMode) return;
  try {
    // Keep the original art pixels; undo the photographed plane's perspective in CSS.
if (!customElements.get('tlt-square-mat')) {
  customElements.define('tlt-square-mat', class extends HTMLElement {
    connectedCallback() {
      if (!this.dataset.matrix) return;
      this.matrix = this.dataset.matrix.split(',').map(Number);
      this.observer = new ResizeObserver(() => this.alignMat());
      this.observer.observe(this);
      this.alignMat();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
    }
    alignMat() {
      const image = this.querySelector('img');
      const width = this.clientWidth;
      const height = this.clientHeight;
      if (!image || !width || !height || this.matrix.length !== 8 || !this.matrix.every(Number.isFinite)) return;
      const [a, b, c, d, e, f, g, h] = this.matrix;
      image.style.transform = `matrix3d(${a},${d * height / width},0,${g / width},${b * width / height},${e},0,${h / height},0,0,1,0,${c * width},${f * height},0,1)`;
      this.dataset.aligned = 'true';
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
